import {ObjectUtil} from '../../util/object-util';

export class Damage {

  year: number = null;
  amountPaid: number = null;
  currency: string = 'EUR';
  reserve: number = null;
  reserveCurrency: string = 'EUR';
  quantity: number = null;
  type: string = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
